/*
  negishot-sticky-offset.js
  ---------------------------------------------------------------------------
  מרים את כפתור הנגישות של Negishot מעט מעל הפס הסטיקי "הוספה לעגלה" במובייל.

  למה צריך קובץ נפרד: התוסף negishot.co.il בונה את עצמו בתוך Shadow DOM —
  <div id="negishot-ui-host"> → shadowRoot → <div id="negishot-widget">
  (position: fixed, inline style bottom: 20px, z-index מקסימלי).
  CSS של התמה לא חוצה את גבול ה-Shadow DOM, ולכן הכללים ב-
  component-sticky-add-to-cart.css (שנכתבו בזמנו לתוסף Enable) לא תופסים כאן,
  והכפתור נשאר בדיוק מעל הפס ומסתיר אותו.

  הפתרון: מזריקים <style> אל תוך ה-shadowRoot עצמו, ומסמנים את ה-host
  במחלקה כשהפס גלוי. המרחק מחושב דינמית מגובה הפס בפועל, כך שהוא נשאר נכון
  גם אם גובה הפס משתנה (מסך צר, safe-area וכו').

  התלות היחידה: sticky-add-to-cart.js כבר מוסיף ל-<body> את המחלקות
  sticky-atc-a11y-shift (כשהפס גלוי) ו-sticky-atc-sheet-open (כששכבת המידה פתוחה).
  ---------------------------------------------------------------------------
*/
(function () {
  var HOST_ID = 'negishot-ui-host';
  var STYLE_ID = 'sticky-atc-a11y-style';
  var GAP = 12; // רווח בפיקסלים בין הפס לכפתור הנגישות
  var hosts = [];
  var lastOffset = 0;

  function bar() {
    return document.querySelector('.sticky-atc');
  }

  function injectStyle(host) {
    if (host.shadowRoot.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#negishot-widget { transition: bottom 0.25s ease !important; }',
      /* מדיה קווארי בתוך Shadow DOM נבדק מול ה-viewport, ולכן זו הדרך לוודא
         שההזזה קורית רק במובייל — בדסקטופ הפס הסטיקי ממילא מוסתר. */
      '@media screen and (max-width: 989px) {',
      '  :host(.sticky-atc-a11y-shift) #negishot-widget {',
      /* ה-inline style של התוסף הוא bottom: 20px ללא important,
         ולכן כלל important מגיליון סגנונות גובר עליו. */
      '    bottom: var(--sticky-atc-a11y-offset, 9rem) !important;',
      '  }',
      '}',
      /* כששכבת בחירת המידה פתוחה — מנטרלים לחיצה על הווידג\'ט,
         כי הוא יושב על אותו z-index מקסימלי ואי אפשר לעקוף אותו בערימה. */
      ':host(.sticky-atc-sheet-open) #negishot-widget,',
      ':host(.sticky-atc-sheet-open) #negishot-panel { pointer-events: none !important; }',
    ].join('\n');
    host.shadowRoot.appendChild(style);
  }

  function updateOffset(force) {
    if (!hosts.length) return;
    var el = bar();
    var height = el ? el.offsetHeight : 0;
    if (!height && !force) return;
    var offset = Math.round((height || 64) + GAP);
    if (offset === lastOffset) return;
    lastOffset = offset;
    hosts.forEach(function (host) {
      host.style.setProperty('--sticky-atc-a11y-offset', offset + 'px');
    });
  }

  function sync() {
    if (!hosts.length) return;
    var shift = document.body.classList.contains('sticky-atc-a11y-shift');
    var sheetOpen = document.body.classList.contains('sticky-atc-sheet-open');
    if (shift) updateOffset();
    hosts.forEach(function (host) {
      host.classList.toggle('sticky-atc-a11y-shift', shift);
      host.classList.toggle('sticky-atc-sheet-open', sheetOpen);
    });
  }

  function scan() {
    var host = document.getElementById(HOST_ID);
    if (!host || !host.shadowRoot || hosts.indexOf(host) !== -1) return false;
    hosts.push(host);
    injectStyle(host);
    updateOffset(true);
    sync();
    return true;
  }

  function init() {
    scan();

    // הסקריפט של התוסף נטען בסוף ה-body ובונה את ה-host באיחור,
    // ולכן ממתינים להופעתו במקום להניח שהוא כבר קיים.
    var hostObserver = new MutationObserver(scan);
    hostObserver.observe(document.documentElement, { childList: true, subtree: true });

    // גיבוי ל-MutationObserver: אם ה-host כבר קיים ב-DOM ורק אחר כך מקבל
    // shadowRoot, שינוי כזה לא מייצר מוטציה שנצפית מה-document — ולכן בלי
    // הפולינג הזה היינו מפספסים את התוסף לגמרי במקרי טעינה מסוימים.
    var poll = window.setInterval(scan, 400);

    window.setTimeout(function () {
      hostObserver.disconnect();
      window.clearInterval(poll);
    }, 30000);

    new MutationObserver(sync).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    var el = bar();
    if (el && window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        updateOffset();
      });
      ro.observe(el);
    }
    window.addEventListener('resize', function () {
      updateOffset();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();